import type { CountryIso, CountryKey } from "~/types";
import { objectEntries } from "./general";

interface Data {
  name: string;
  iso: CountryIso;
  iso2: string;
  path: string;
  extraIso?: CountryIso;
}

export const VISA_COUNTRIES: Record<CountryKey, Data> = {
  india: {
    name: 'India',
    iso: 'IND',
    iso2: 'IN',
    path: '/india'
  },
  canada: {
    name: 'Canada',
    iso: 'CAN',
    iso2: 'CA',
    path: '/canada'
  },
  sri_lanka: {
    name: 'Sri Lanka',
    iso: 'LKA',
    iso2: 'LK',
    path: '/sri-lanka'
  },
  morocco: {
    name: 'Morocco',
    iso: 'MAR',
    iso2: 'MA',
    path: '/morocco'
  },
  new_zealand: {
    name: 'New Zealand',
    iso: 'NZL',
    iso2: 'NZ',
    path: '/new-zealand'
  },
  vietnam: {
    name: 'Vietnam',
    iso: 'VNM',
    iso2: 'VN',
    path: '/vietnam'
  },
  usa: {
    name: 'United States',
    iso: 'USA',
    iso2: 'US',
    path: '/us'
  },
  korea: {
    name: 'South Korea',
    iso: 'KOR',
    iso2: 'KR',
    path: '/korea'
  },
  cambodia: {
    name: 'Cambodia',
    iso: 'KHM',
    iso2: 'KH',
    path: '/cambodia'
  },
  israel: {
    name: 'Israel',
    iso: 'ISR',
    iso2: 'IL',
    path: '/israel'
  },
  saudi_arabia: {
    name: 'Saudi Arabia',
    iso: 'SAU',
    iso2: 'SA',
    path: '/saudi-arabia'
  },
  bahrain: {
    name: 'Bahrain',
    iso: 'BHR',
    iso2: 'BH',
    path: '/bahrain'
  },
  indonesia: {
    name: 'Indonesia',
    iso: 'IDN',
    iso2: 'ID',
    path: '/indonesia'
  },
  uk: {
    name: 'United Kingdom',
    iso: 'GBR',
    iso2: 'GB',
    path: '/uk'
  },
  togo: {
    name: 'Togo',
    iso: 'TGO',
    iso2: 'TG',
    path: '/togo'
  },
  thailand: {
    name: 'Thailand',
    iso: 'THA',
    iso2: 'TH',
    path: '/thailand'
  },
  schengen: {
    name: 'Schengen Area',
    iso: 'SCH',
    iso2: 'SC',
    path: '/schengen',
    extraIso: 'FRA'
  }
};

export function getVisaCountryIsoCode(key: CountryKey) {
  return VISA_COUNTRIES[key].iso;
}

export function getVisaCountryIso2Code(key: CountryKey) {
  return VISA_COUNTRIES[key].iso2;
}

export function getVisaCountryName(key: CountryKey) {
  return VISA_COUNTRIES[key].name;
}

export function getVisaCountryPath(key: CountryKey) {
  return VISA_COUNTRIES[key].path;
}

export function getVisaCountryPaths() {
  return Object.values(VISA_COUNTRIES).map(country => country.path);
}

export function getVisaCountryExtraIso(key: CountryKey) {
  return VISA_COUNTRIES[key].extraIso;
}

export function getVisaCountryByPath(path: string) {
  for (const [key, value] of objectEntries(VISA_COUNTRIES)) {
    if (path.startsWith(value.path)) return key;
  }
  return null;
}